import { requests } from "./api-config";
export const Auth = {
  login: (data) => requests.post(null, "auth/login", JSON.stringify(data) , `application/json` ),
  logout: (data) => requests.post(true, "auth/logout",  JSON.stringify(data),  `application/json` ),
  refreshTokens: (data) => requests.post(true, "auth/refresh-tokens",  JSON.stringify(data),  `application/json` ),
};


// /v1/auth/login 200